// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unauthorized__container-a770d9 {
  height: var(--app-height);
  box-sizing: border-box;
  background-color: var(--base-0);
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 428px) {
  .unauthorized__container-a770d9 {
    align-items: normal;
  }
}`, "",{"version":3,"sources":["webpack://./src/unauthorized/UnauthorizedView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,sBAAA;EACA,+BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE;IACE,mBAAA;EACF;AACF","sourcesContent":[".container {\n  height: var(--app-height);\n  box-sizing: border-box;\n  background-color: var(--base-0);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@media (max-width: 428px) {\n  .container {\n    align-items: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `unauthorized__container-a770d9`
};
module.exports = ___CSS_LOADER_EXPORT___;
